import {
  START_DEPARTURE_SERVICE_FAILED,
  START_DEPARTURE_SERVICE_LOADING,
  START_DEPARTURE_SERVICE_SUCCESS,
} from "../types"

const initialState = {
  loading: false,
  error: false,
  message: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case START_DEPARTURE_SERVICE_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        message: null,
      }
    case START_DEPARTURE_SERVICE_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
      }
    case START_DEPARTURE_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: null,
      }
    default:
      return state
  }
}
